import api from 'api';
import convert from 'api/convert';
import { IDocumentInfo, ILocale } from 'interfaces';
import getFilenameFromResponse from './getFilenameFromResponse';

const storageType = window.REACT_APP_STORAGE_TYPE !== 'REPLACE_REACT_APP_STORAGE_TYPE' ? window.REACT_APP_STORAGE_TYPE : process.env.REACT_APP_STORAGE_TYPE || 'S3';
const baseURL = window.REACT_APP_SERVER_API !== 'REPLACE_REACT_APP_SERVER_API' ? window.REACT_APP_SERVER_API : process.env.REACT_APP_SERVER_API || 'http://localhost:8000/api';

export const requestPDFFile = async (payload: IDocumentInfo & ILocale) => {
  if (payload.is_temp_links) {
    //логика для temp-link документов
    const convertResponse = await api.convertTempLinkRequest({
      temp_link_id: payload.token,
      password: payload.password,
      is_agreement: payload.is_agreement,
    });

    if ('status' in convertResponse.data && convertResponse.data.status === 'ready') {
      const file = await api.getConvertedFile(
        { ...payload, token: payload.token, is_webview: true, locale: payload.locale },
        payload.signal
      );
      const filename = getFilenameFromResponse(file);
      const fileURL = window.URL.createObjectURL(file.data as Blob);
      return { fileURL, filename: filename === 'undefined' ? '' : filename };
    }
    else if ('status' in convertResponse.data && convertResponse.data.status === 'in_progress') {
      return { fileURL: false, document: payload };
    }
  } else {
    const convertStatus = await api.convertRequest(
      { ...payload, is_webview: true, locale: payload.locale },
      payload.signal
    );
    if (convertStatus.data.status === 'ready') {
      const file = await api.getConvertedFile(
        { ...payload, is_webview: true, locale: payload.locale },
        payload.signal
      );
      const filename = getFilenameFromResponse(file);
      const fileURL = window.URL.createObjectURL(file.data as Blob);
      return { fileURL, filename: filename === 'undefined' ? '' : filename };
    } else if (convertStatus.data.status === 'in_progress') {
      return { fileURL: false, document: payload };
    }
  }
};

export const getPathToDocument = async (payload: IDocumentInfo & ILocale) => {
  const response = await convert.convertDocument({ ...payload, is_webview: true, locale: payload.locale });
  const filename = getFilenameFromResponse(response)  
  const fileURL = window.URL.createObjectURL(response.data as Blob);  
  return {fileURL, filename: filename === 'undefined' ? '' : filename};
};

export const getTableFile = async (payload: IDocumentInfo) => {
  const response = await api.viewFile({ ...payload, is_webview: true });
  const filename = getFilenameFromResponse(response)  
  const fileURL = new File([response.data], 'some.xlsx');
  return {fileURL, filename: filename === 'undefined' ? '' : filename};
};

export const getPathToImage = async (payload: IDocumentInfo) => {
  const response = await api.viewFile({ ...payload, is_webview: true });
  const filename = getFilenameFromResponse(response)  
  const fileURL = window.URL.createObjectURL(response.data as Blob);
  return {fileURL, filename: filename === 'undefined' ? '' : filename};
};

export const getPathToVideo = async (payload: IDocumentInfo) => {
  let filename = ''
  let fileURL = '';  
  if (storageType?.toLowerCase() === 's3') {
    const response = await api.getVideoLink({token: payload.token, is_temp_links: payload.is_temp_links})
    fileURL = response.data;
    filename = getFilenameFromResponse(response)
  } else {
    fileURL = `${baseURL}/documents/manifest/?token=${payload.token}`
  }
  return {fileURL, filename: filename === 'undefined' ? '' : filename};
};
